import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-common',
  templateUrl: './footer-common.component.html',
  styleUrls: ['./footer-common.component.scss']
})
export class FooterCommonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
